class MainProductSystemConfiguration extends HTMLElement {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.cartCountBubble = document.querySelector("#cart-icon-bubble");
  }

  connectedCallback() {
    this.systemConfigItemsContainer = this.querySelector(
      "#system-configuration-item--container"
    );
    this.addToCartBtn = this.querySelector(
      "#main-product-system-configuration--add-to-cart"
    );

    this.sizeError = this.querySelector(
      `#main-product-system-configuration--size-error`
    );

    this.systemConfigItemsContainer.addEventListener(
      "click",
      this.configItemsEventHandler.bind(this)
    );

    this.addToCartBtn.addEventListener(
      "click",
      this.addToCartBtnHandler.bind(this)
    );
    this.setSystemPrice();
  }

  disconnectedCallback() {
    this.systemConfigItemsContainer.removeEventListener("click");
  }

  configItemsEventHandler(event) {
    const systemConfigItem = event.target.closest(
      "button.system-configuration-item"
    );
    if (!systemConfigItem) return;

    this.toggleSizeSelectors(systemConfigItem);
    this.toggleActiveSizeSelector(systemConfigItem);
    this.setSystemPrice();
    this.setProductSaleTag();
  }

  toggleActiveSizeSelector(systemConfigItem) {
    let prevActiveItem = this.querySelector(
      `.system-configuration-item.active`
    );
    prevActiveItem.classList.remove("active");
    systemConfigItem.classList.add("active");
  }

  toggleSizeSelectors(systemConfigItem) {
    systemConfigItem = systemConfigItem
      ? systemConfigItem
      : this.systemConfigItemsContainer.querySelector(
          "button.system-configuration-item"
        );
    this.querySelectorAll(`product-system-size-selector`).forEach((el) => {
      el.classList.add("dawn-hidden");
      el.querySelector(
        ".system-configuration-item--variants-container"
      ).classList.add("dawn-hidden");
      el.querySelectorAll(`input[type="radio"]`).forEach(
        (input) => (input.checked = false)
      );
    });

    let selectedItemSizes = this.querySelector(
      `product-system-size-selector[data-system-handle="${systemConfigItem.dataset.systemHandle}"]`
    );
    selectedItemSizes.classList.remove("dawn-hidden");
    this.toggleActiveSizeSelector(systemConfigItem);
  }

  setSystemPrice() {
    let activeSystem = this.querySelector(`.system-configuration-item.active`);
    let price = activeSystem.querySelector(
      ".system-configuration-item--price"
    ).innerHTML;
    this.addToCartBtn.innerHTML = `<span>Add To Cart - </span> ${price}`;
  }

  setProductSaleTag() {
    const productSaleTag = this.closest(
      ".product__info-container"
    ).querySelector(`.product-sale-tag`);
    const activeSystem = this.querySelector(
      `.system-configuration-item.active`
    );
    if (!productSaleTag || !activeSystem) return;
    const activeSystemSaleTag = activeSystem.querySelector(
      ".system-configuration-item--sale-tag"
    );
    productSaleTag.innerText = activeSystemSaleTag.innerText;
  }

  addToCartBtnHandler(event) {
    let btn = event.target.closest(
      "#main-product-system-configuration--add-to-cart"
    );
    if (!btn) return;

    let variant = this.querySelector(
      `product-system-size-selector input[type="radio"]:checked`
    )?.value;

    if (!variant) {
      this.setErrorSizeErrorMessage(true);
      return;
    }

    const isSystemBundleItemSelected = this.querySelector(
      ".system-configuration-item.system-bundle-item.active"
    );

    if (isSystemBundleItemSelected) {
      this.systemBundleController();
      return;
    }

    let cartData = {
      items: [
        {
          id: variant,
          quantity: 1,
        },
      ],
    };
    this.addToCart(cartData);
  }

  systemBundleController() {
    const bundleItem = this.querySelector(
      ".system-configuration-item.system-bundle-item.active"
    );
    let { bundleProductsSettings } = bundleItem.dataset;

    let size = this.querySelector(
      `product-system-size-selector input[type="radio"]:checked`
    ).value;
    let sizeOptions = size.includes("-") ? size.split("-") : false;

    let itemsForCart = bundleProductsSettings.split(":::").map((item) => {
      let [_, variantOptions] = item.split("=");

      // Check if this is the body pillow cover that needs special handling
      let isBodyPillowCover = _.includes(
        "extra-case-for-therapeutic-body-pillow-gray"
      );

      let selected_option = variantOptions.split(",").find((option) => {
        // Override: Always select medium-large for body pillow cover
        if (isBodyPillowCover) {
          return option.includes("medium-large");
        }

        // Original logic for other products
        if (sizeOptions) {
          return option.includes(sizeOptions[0] || sizeOptions[1]);
        } else {
          return option.includes(size);
        }
      });

      if (!selected_option) return;
      let [__, id] = selected_option.split("::");
      return {
        id,
        quantity: 1,
        properties: {
          _bundle_handle: `deluxe-gray-shoulder-system`,
        },
      };
    });

    let cartData = {
      items: itemsForCart,
    };

    this.addToCart(cartData);
  }

  async addToCart(cartData) {
    this.setLoadingToAddToCart(true);
    try {
      const addResponse = await fetch(
        window.Shopify.routes.root + "cart/add.js",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(cartData),
        }
      );
      const data = await addResponse.json();
      if (!addResponse.ok) throw new Error(`${data.description}`);
      if (window._learnq) {
        window._learnq.push(["track", "Added to Cart", variant]);
      }
    } catch (error) {
      console.log(`${error}`);
    } finally {
      this.setLoadingToAddToCart(false);
      this.openAndPopulateCart();
      this.toggleSizeSelectors();
      this.querySelectorAll("product-system-size-selector").forEach((el) =>
        el.resetToDefaultValue()
      );
    }
  }

  setLoadingToAddToCart(flag) {
    this.addToCartBtn.disabled = flag;
    this.addToCartBtn.ariaDisabled = flag;
    flag
      ? (this.addToCartBtn.innerHTML = "<span>Adding to cart </span>")
      : this.setSystemPrice();
  }

  async openAndPopulateCart() {
    // Fetch the updated cart drawer content from the server
    const response = await fetch("/cart");
    const responseText = await response.text();

    // Parse the fetched HTML response into a DOM document
    const newCartMarkup = new DOMParser().parseFromString(
      responseText,
      "text/html"
    );

    // Update cart icon bubble
    const newCartIconBubbleMarkup =
      newCartMarkup.querySelector("#cart-icon-bubble");
    this.cartCountBubble.innerHTML = newCartIconBubbleMarkup.innerHTML;

    // Remove empty class
    this.cartDrawer.classList.remove("is-empty");

    // Get new cart drawer markup
    const newCartDrawerMarkup = newCartMarkup.querySelector("#CartDrawer");

    // Replace markup
    this.cartDrawer
      .querySelector("#CartDrawer")
      .replaceWith(newCartDrawerMarkup);

    // Open cart
    this.cartDrawer.open();

    this.cartDrawer.hideInstallmentsCTA();
  }

  setErrorSizeErrorMessage(flag = false) {
    if (flag) {
      this.sizeError.classList.remove("dawn-hidden");
      this.addToCartBtn.disabled = true;
      return;
    }
    this.sizeError.classList.add("dawn-hidden");
    this.addToCartBtn.disabled = false;
  }
}

class ProductSystemSizeSelector extends HTMLElement {
  constructor() {
    super();
    this.addToCartBtn = document.querySelector(
      "#main-product-system-configuration--add-to-cart"
    );

    this.sizeError = document.querySelector(
      `#main-product-system-configuration--size-error`
    );
  }

  connectedCallback() {
    this.cta = this.querySelector(".system-configuration-item--cta");
    this.ctaPlaceholder = this.querySelector(
      ".system-configuration-item--size-selector-placeholder-copy"
    );
    this.ctaSelectedSize = this.querySelector(
      ".system-configuration-item--size-selector-selected-size"
    );
    this.variantsContainer = this.querySelector(
      ".system-configuration-item--variants-container"
    );
    this.cta.addEventListener("click", this.configurationCTAHandler.bind(this));
    this.variantsContainer.addEventListener(
      "click",
      this.variantsContainerEventHandler.bind(this)
    );

    document.addEventListener(
      "click",
      (this.handleOutsideClickBound = this.handleOutsideClick.bind(this))
    );
  }

  disconnectedCallback() {
    this.cta.removeEventListener(
      "click",
      this.configurationCTAHandler.bind(this)
    );
    document.removeEventListener("click", this.handleOutsideClickBound);
  }

  configurationCTAHandler(event) {
    let btn = event.target.closest(".system-configuration-item--cta");
    if (!btn) return;
    this.variantsContainer.classList.toggle("dawn-hidden");
  }

  variantsContainerEventHandler(event) {
    let label = event.target.closest("label");
    if (!label) return;
    this.ctaSelectedSize.innerHTML = label.innerHTML;

    if (this.ctaSelectedSize.classList.contains("dawn-hidden")) {
      this.ctaSelectedSize.classList.remove("dawn-hidden");
    }

    this.ctaPlaceholder.classList.add("dawn-hidden");

    label
      .closest(".system-configuration-item--variants-container")
      .classList.add("dawn-hidden");

    this.setErrorSizeErrorMessage(false);
  }

  resetToDefaultValue() {
    this.ctaPlaceholder.classList.remove("dawn-hidden");
    this.ctaSelectedSize.classList.add("dawn-hidden");
  }

  setErrorSizeErrorMessage(flag = false) {
    if (flag) {
      this.sizeError.classList.remove("dawn-hidden");
      this.addToCartBtn.disabled = true;
      return;
    }
    this.sizeError.classList.add("dawn-hidden");
    this.addToCartBtn.disabled = false;
  }
  handleOutsideClick(event) {
    if (!this.contains(event.target)) {
      this.variantsContainer.classList.add("dawn-hidden");
    }
  }
}

customElements.define(
  "product-system-size-selector",
  ProductSystemSizeSelector
);

customElements.define(
  "main-product-system-configuration",
  MainProductSystemConfiguration
);
